import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput, SwitchInput } from '../Form';
import { token } from '../../libs/localStorage';
import { getDisplayDate } from '../../libs/date';
import Modal from '../Modal';
import FormMultiSelectInput from '../FormMultiSelectInput';
import moment from "moment";

@inject('ticketStore', 'stationStore', 'userStore', 'ticketStatusStore', 'ticketReasonStore', 'ticketActionStore', 'rolePermissionStore', 'tripStore')
@observer
class TripEdit extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = this.props.params.ticket_id ? `/station/${this.props.params.id}/maintenance/ticket` : '/monitoring/trip';
  title = 'Edit Trip';

  @observable item = {};
  @observable multiUserOptions = [];
  @action onChangeStartDate = e => this.item.start_date = e.target.value;
  @action onChangeEndDate = e => this.item.end_date = e.target.value;
  @action onChangePlannedBy = e => this.item.planned_by = +e.target.value;

  @action onCommutatorsSelect = (item) => {
    item.value = !item.value;
    this.multiUserOptions.filter(t => +t.id === +item.id).forEach(t => t.value = item.value);
  }

  constructor(props) {
    super(props);

    const { params: { id }, tripStore, userStore } = this.props;
    tripStore.fetchItem(id);
    if (userStore.items && userStore.items.length > 0) {
      if (this.multiUserOptions.length === 0) {
        const newMultiUserOptions = userStore.items.map(item => ({
          id: item.id,
          name: item.name,
          email: item.email,
          label: item.name,
          value: false
        }));
        this.multiUserOptions = newMultiUserOptions;
      }
    }
  }

  componentWillMount() {
    this.reset();
  }

  @action reset() {
    const { params: { id }, tripStore } = this.props;
    const foundItem = tripStore.findById(id);
    const commutators = toJS(foundItem && foundItem.commutators || [])
    this.multiUserOptions = this.multiUserOptions.map((item) => ({
      ...item,
      value:commutators.includes(item.id)
    }))
;
    if (foundItem) {
      this.item = observable(Object.assign({}, foundItem.asJson));
    }
  }

  handleSave = (e) => {
    e.preventDefault();

    const { tripStore, userStore, stationStore } = this.props;
    const { notify, router } = this.context;
    const {
      id,
      commutators,
      end_date,
      planned_by,
      start_date
    } = this.item;


    const commutatorsId = this.multiUserOptions.filter(i => i.value == true).map(j => j.id)
    tripStore.updateItem({
    id,commutators:commutatorsId,end_date,planned_by,start_date
    }).then(() => {
      notify.success({ message: "Saved" })
      router.push(this.slug);
      tripStore.fetchItems()
    }).catch((e) => notify.error({ message: e.toString() }));
  }

  render() {
    const { ticketStore, params: { id, ticket_id }, stationStore, userStore, ticketStatusStore, ticketReasonStore, ticketActionStore, rolePermissionStore } = this.props;

    const hasUserPermission = rolePermissionStore.validateRole('view user');

    return (
      <Modal title={this.title} slug={this.slug} isSaving={ticketStore.isSaving}>
        <Form>
          <FormBody>
            <DateInput label='Start Date' value={moment(this.item.start_date).format('YYYY-MM-DD')} onChange={this.onChangeStartDate} />
            <DateInput label='End Date' value={moment(this.item.end_date).format('YYYY-MM-DD')} onChange={this.onChangeEndDate} />
            <FormMultiSelectInput id='user-multi-select' label='Commutators' options={this.multiUserOptions} optionClicked={this.onCommutatorsSelect} loading={false} hideSelectAll hideClearAll />
            {hasUserPermission && <SelectInput
              id={'Planned By'}
              label={'Planned By'}
              value={this.item.planned_by}
              options={userStore.items}
              onChange={this.onChangePlannedBy}
              fields={{
                label: 'name',
                value: 'id',
              }}
            />}


          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default TripEdit;



// WEBPACK FOOTER //
// ./src/components/Trips/TripEdit.js